import React from "react";
import {
  Modal,
  ModalDialog,
  DialogTitle,
  Stack,
  Typography,
  FormControl,
  FormLabel,
  Select,
  Option,
  Button,
  Alert,
} from "@mui/joy";
import { AccessRequest } from "../../common/types";

interface ApproveAccessRequestModalProps {
  open: boolean;
  onClose: () => void;
  request: AccessRequest | null;
  approveRole: "admin" | "member";
  onApproveRoleChange: (role: "admin" | "member") => void;
  onApprove: () => void;
  approving: boolean;
}

const ApproveAccessRequestModal: React.FC<ApproveAccessRequestModalProps> = ({
  open,
  onClose,
  request,
  approveRole,
  onApproveRoleChange,
  onApprove,
  approving,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        size="md"
        variant="outlined"
        sx={{
          maxWidth: 500,
          width: "100%",
        }}
      >
        <DialogTitle>Approve Access Request</DialogTitle>

        <Stack spacing={3}>
          <Typography level="body-md">
            Approve access request from <strong>{request?.email}</strong>?
          </Typography>

          <FormControl required>
            <FormLabel>Assign Role</FormLabel>
            <Select
              value={approveRole}
              onChange={(_, value) =>
                onApproveRoleChange(value as "admin" | "member")
              }
              disabled={approving}
              size="md"
            >
              <Option value="member">Member</Option>
              <Option value="admin">Administrator</Option>
            </Select>
          </FormControl>

          {request?.access_request_message && (
            <Alert variant="soft" color="neutral">
              <Typography level="body-sm" sx={{ fontWeight: 600, mb: 0.5 }}>
                Request Message:
              </Typography>
              <Typography level="body-sm">
                {request.access_request_message}
              </Typography>
            </Alert>
          )}

          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "flex-end", mt: 2 }}
          >
            <Button
              variant="outlined"
              color="neutral"
              onClick={onClose}
              disabled={approving}
              size="md"
            >
              Cancel
            </Button>
            <Button
              variant="solid"
              color="success"
              onClick={onApprove}
              disabled={approving}
              loading={approving}
              size="md"
            >
              Approve Request
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};

export default ApproveAccessRequestModal;
